import React from 'react';
import { TrendingUp, Coffee, Activity } from 'lucide-react';
import { deepDiveFeatures } from '../mockData';

const iconMap = {
  TrendingUp: TrendingUp,
  Coffee: Coffee,
  Activity: Activity
};

const colorMap = {
  blue: {
    bg: 'from-blue-500/20 to-blue-600/20',
    border: 'border-blue-500/30',
    icon: 'text-blue-400'
  },
  slate: {
    bg: 'from-slate-500/20 to-slate-600/20',
    border: 'border-slate-500/30',
    icon: 'text-slate-300'
  },
  purple: {
    bg: 'from-purple-500/20 to-purple-600/20',
    border: 'border-purple-500/30',
    icon: 'text-purple-400'
  }
};

const DeepDive = () => {
  return (
    <section id="about" className="bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Deep Dive into Marketwise AI
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Discover the technology that powers our industry-leading win rates.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {deepDiveFeatures.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            const colors = colorMap[feature.color];
            return (
              <div
                key={index}
                className="group bg-gradient-to-br from-slate-900/80 to-slate-900/50 backdrop-blur-sm border border-slate-800/50 rounded-2xl p-8 hover:border-cyan-500/50 transition-all duration-300"
              >
                <div className={`w-16 h-16 bg-gradient-to-br ${colors.bg} border ${colors.border} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-all duration-300`}>
                  <IconComponent className={`w-8 h-8 ${colors.icon}`} />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">{feature.title}</h3>
                <p className="text-slate-400 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DeepDive;
